var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 59,
    viewBox: "0 0 49 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C12.25 0 0 1.55263 0 12.4211V41.9211C0 47.9142 4.80813 52.7895 10.7188 52.7895L6.125 57.4474V59H12.25L18.375 52.7895H30.625L36.75 59H42.875V57.4474L38.2812 52.7895C44.1919 52.7895 49 47.9142 49 41.9211V12.4211C49 1.55263 36.75 0 24.5 0ZM24.5 6.21053C35.2494 6.21053 39.69 7.70105 41.5581 9.31579H7.44187C9.31 7.70105 13.7506 6.21053 24.5 6.21053ZM6.125 15.5263H21.4375V24.8421H6.125V15.5263ZM42.875 41.9211C42.875 44.4984 40.8231 46.5789 38.2812 46.5789H10.7188C8.17688 46.5789 6.125 44.4984 6.125 41.9211V31.0526H42.875V41.9211ZM42.875 24.8421H27.5625V15.5263H42.875V24.8421Z",
    fill: "#3EAB36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.d58a5c221d5573f05682f1a04d521be7.svg";
export { ForwardRef as ReactComponent };